module.exports = __webpack_public_path__ + "media/images/3-a2d3ddbf70eccb7ef4f77baad30a92d5.png";